import { StrictMode } from "react";

import type { Flipper } from "@shared/types/flipper";
import { ErrorBoundary, Providers } from "@unauthenticated/signupSignin/components";
import type { PatientAttributes } from "@unauthenticated/signupSignin/data/types";

import { Pages } from "./Pages";

interface Props {
  emailRegex: string;
  treatmentPlanTerm: string;
  currentCountry: string;
  csuid: string;
  flippers: Flipper[];
  roleId: string;
  storeId: string;
  e2e: boolean;
  patientAttributes: PatientAttributes;
  additionalAttributes?: any;
  ssoErrors?: string;
  isPreview?: boolean;
  isStoreOwner: boolean;
  analyticsAnonymousId: string;
}

const StoreLandingEntryPoint = ({
  emailRegex,
  treatmentPlanTerm,
  currentCountry,
  csuid,
  flippers,
  roleId,
  storeId,
  e2e,
  patientAttributes,
  additionalAttributes,
  ssoErrors,
  isPreview,
  isStoreOwner,
  analyticsAnonymousId,
}: Props) => {
  const pageVersion = "react_with_sso";

  return (
    <StrictMode>
      <Providers
        emailRegex={emailRegex}
        treatmentPlanTerm={treatmentPlanTerm}
        currentCountry={currentCountry}
        flippers={flippers}
        e2e={e2e}
        analyticsAnonymousId={analyticsAnonymousId}
      >
        <ErrorBoundary {...{ flippers, csuid, roleId, storeId, pageVersion }}>
          <Pages
            patientAttributes={patientAttributes}
            additionalAttributes={additionalAttributes}
            csuid={`${csuid}`}
            pageVersion={pageVersion}
            ssoErrors={ssoErrors}
            isPreview={isPreview}
            isStoreOwner={isStoreOwner}
            storeId={storeId}
          />
        </ErrorBoundary>
      </Providers>
    </StrictMode>
  );
};

export { StoreLandingEntryPoint };
